import { BaseAdapter } from './base.adapter';
import type { GoldenCaseList, GoldenCaseListResponseDto, GoldenCaseRow, GoldenCaseRowResponseDto, GoldenTab } from '@/types/golden.types';

/** Golden accounts have no brand name of their own in the case; 811 is the only named one. */
const BRAND_NAMES: Record<number, string> = { 811: 'Buoy' };

export class GoldenAdapter extends BaseAdapter {
  static brandName(accountId: number): string {
    return BRAND_NAMES[accountId] ?? `Account ${accountId}`;
  }

  static fromRowApi(dto: GoldenCaseRowResponseDto, tab: GoldenTab): GoldenCaseRow {
    return {
      id: dto.caseId,
      accountId: dto.accountId,
      brand: GoldenAdapter.brandName(dto.accountId),
      frameDay: dto.frameDay,
      shortId: dto.case ?? dto.caseId,
      channel: dto.channel ?? '',
      position: dto.position ?? '',
      received: dto.received ?? '',
      status: dto.tab ?? tab,
    };
  }

  static fromListApi(dto: GoldenCaseListResponseDto, tab: GoldenTab): GoldenCaseList {
    return {
      rows: dto.rows.map((row) => GoldenAdapter.fromRowApi(row, tab)),
      counts: { ...dto.counts },
    };
  }
}
